import { Html } from "@custom/schema";
import clsx from "clsx";
import React from "react";
export function BlockIntro(props) {
    var _props_bgStyle;
    var bgStyle = (_props_bgStyle = props.bgStyle) !== null && _props_bgStyle !== void 0 ? _props_bgStyle : "gray";
    var _props_whiteTopTriangle;
    var whiteTopTriangle = (_props_whiteTopTriangle = props.whiteTopTriangle) !== null && _props_whiteTopTriangle !== void 0 ? _props_whiteTopTriangle : true;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx("px-6 md:px-20 lg:px-14 pb-3 md:py-16 pt-12 relative content-text-bg", {
            "white-triangle-top bg-gray-30 lg:py-20": bgStyle !== "white" && whiteTopTriangle,
            "bg-gray-30 lg:py-20": bgStyle !== "white" && !whiteTopTriangle,
            "pt-8 md:pt-14": bgStyle === "white"
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("mx-auto text-center", {
            "max-w-3xl": bgStyle !== "white",
            "max-w-4xl": bgStyle === "white"
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx([
            "mx-auto max-w-full prose content-text-bg lg:text-lg xl:text-xl "
        ])
    }, (props === null || props === void 0 ? void 0 : props.headingIntro) && /*#__PURE__*/ React.createElement("h2", {
        className: "mt-0"
    }, props === null || props === void 0 ? void 0 : props.headingIntro), /*#__PURE__*/ React.createElement(Html, {
        markup: props.markup
    }), props.introCtas ? /*#__PURE__*/ React.createElement("div", {
        className: "md:flex flex-col md:flex-row md:items-start md:gap-x-4 justify-center mt-7 md:mt-9"
    }, props.introCtas.filter(function(item) {
        return item === null || item === void 0 ? void 0 : item.label;
    }).map(function(cta, key) {
        /*#__PURE__*/ return React.createElement("a", {
            key: key,
            href: cta === null || cta === void 0 ? void 0 : cta.target,
            className: clsx("block w-auto mb-4 md:mb-5 lg:mb-0 no-underline md:text-base", {
                "button-secondary focus bg-gray-30 border-gray-600 text-gray-600 hover:bg-blue-500 hover:border-blue-500 hover:text-white": (cta === null || cta === void 0 ? void 0 : cta.display) === "PRIMARY",
                "button-secondary border-gray-600 text-white bg-gray-600 hover:bg-blue-500 hover:border-blue-500": (cta === null || cta === void 0 ? void 0 : cta.display) === "SECONDARY"
            })
        }, cta === null || cta === void 0 ? void 0 : cta.label);
    })) : null)));
}
